export default "__VITE_ASSET__DnxIuq$j__"